import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useMutation, useQuery } from "react-query"
import { useMarina } from "src/contexts/MarinaContext"

import Modal from "src/components/Modal"

import {
  previewBulkMessage,
  sendBulkMessage,
} from "src/api/Manage/Reservations"

import BulkMessageCompose from "./BulkMessageCompose"
import BulkMessageConfirm from "./BulkMessageConfirm"

const BulkMessageModal = ({ isOpen, onClose, onSuccess, selection, night }) => {
  const [step, setStep] = useState("compose")
  const [message, setMessage] = useState("")
  const { marinaSlug } = useMarina()

  const { data: recipients, isLoading: isLoadingPreview } = useQuery(
    ["bulkMessagePreview", marinaSlug, selection, night],
    () =>
      previewBulkMessage({
        marinaSlug,
        night,
        ids: selection,
      }),
    {
      enabled: isOpen && Boolean(marinaSlug) && selection.length > 0,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    }
  )

  const sendMutation = useMutation(
    (params) => sendBulkMessage({ marinaSlug, night, ...params }),
    {
      onSuccess: (data) => {
        onSuccess(data?.messagesCreated || recipients?.totalValid || 0)
      },
    }
  )

  useEffect(() => {
    if (isOpen) {
      setStep("compose")
      setMessage("")
    }
  }, [isOpen])

  const handleSend = () => {
    const validIds = recipients.validRecipients.map((r) => r.id)
    sendMutation.mutate({
      reservationIds: validIds,
      message,
    })
  }

  const isBulk = selection.length > 1

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Header title={isBulk ? "Send Bulk Message" : "Send Message"} />
      <Modal.Body>
        {step === "compose" ? (
          <BulkMessageCompose
            message={message}
            onChange={setMessage}
            selectedCount={selection.length}
            validCount={recipients?.totalValid}
            invalidCount={recipients?.totalInvalid}
            onNext={() => setStep("confirm")}
            isLoading={isLoadingPreview}
          />
        ) : (
          <BulkMessageConfirm
            message={message}
            recipients={recipients}
            onBack={() => setStep("compose")}
            onSend={handleSend}
            isSending={sendMutation.isLoading}
          />
        )}
      </Modal.Body>
    </Modal>
  )
}

BulkMessageModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  selection: PropTypes.arrayOf(PropTypes.string).isRequired,
  night: PropTypes.string.isRequired,
}

export default BulkMessageModal
